import { DocumentText1, Clock, CloseCircle, Edit2 } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";
import type { AdvanceStatus } from "../types";

interface AdvanceStatusConfig {
  label: string;
  color: "gray" | "info" | "positive" | "notice" | "negative";
  icon: React.ReactNode;
}

export const ADVANCE_STATUS_MAP: Record<AdvanceStatus, AdvanceStatusConfig> = {
  draft: {
    label: "statusLabels.draft",
    color: "info",
    icon: <DocumentText1 size={14} color="currentColor" />,
  },
  signing_pending: {
    label: "statusLabels.signing_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  pending: {
    label: "statusLabels.pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  approved: {
    label: "statusLabels.approved",
    color: "positive",
    icon: <CheckIcon />,
  },
  order_pending: {
    label: "statusLabels.order_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  order_acknowledged: {
    label: "statusLabels.order_acknowledged",
    color: "positive",
    icon: <CheckIcon />,
  },
  rejected: {
    label: "statusLabels.rejected",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
  revision: {
    label: "statusLabels.revision",
    color: "notice",
    icon: <Edit2 size={14} color="currentColor" />,
  },
  issued: {
    label: "statusLabels.issued",
    color: "positive",
    icon: <CheckIcon />,
  },
  settled: {
    label: "statusLabels.settled",
    color: "positive",
    icon: <CheckIcon />,
  },
};

export function getAdvanceStatusConfig(status: string): AdvanceStatusConfig {
  return (
    ADVANCE_STATUS_MAP[status as AdvanceStatus] ?? {
      label: `statusLabels.${status}`,
      color: "gray",
      icon: <DocumentText1 size={14} color="currentColor" />,
    }
  );
}
